// Style included toppings
const styleIncludedToppings = [
  {
    style_id: 2, // Special
    topping_id: 3 // Coleslaw
  },
  {
    style_id: 3, // Super
    topping_id: 1 // Lettuce
  },
  {
    style_id: 3, // Super
    topping_id: 2 // Tomato
  }
];

export default styleIncludedToppings;